import type { NodeProps } from '@xyflow/react';
import type { CanvasNodeData } from '@/hooks/useProcessCanvas';
import { BaseNode } from './BaseNode';

export function TriggerNode({ id, data }: NodeProps) {
  const d = data as unknown as CanvasNodeData;

  return (
    <BaseNode
      nodeId={id}
      label={d.label}
      description={d.description}
      sourceType={d.sourceType}
      canvasNodeType="trigger"
      edgeCount={d.edgeCount}
      subType={d.subType ?? undefined}
      staged={d.staged}
      contextCount={d.additionalContext?.length ?? 0}
    />
  );
}
